import type { FlagValue } from './toggle-client'

/**
 * Casts the flag value by checking if the type is what was expected.
 *
 * @param value
 * @param defaultValue
 */
export function castFlagValue<T extends FlagValue>(
  value: unknown,
  defaultValue: T,
): T {
  if (value === null || value === undefined) {
    return defaultValue
  }

  // Otherwise, coerce to the type of the default value.
  switch (typeof defaultValue) {
    case 'boolean':
      return Boolean(value) as T
    case 'number':
      return typeof value === 'string' ? (parseFloat(value) as T) : defaultValue
    case 'string':
      return value as T
  }
}
